module.exports = __webpack_public_path__ + "static/media/BookmarkApp.397e5ff6.jpg";